import keysToConstants from 'js/lib/keysToConstants';

const S12nRoles = keysToConstants(['NOT_ENROLLED', 'LEARNER']);

export const { NOT_ENROLLED, LEARNER } = S12nRoles;

export default S12nRoles;
